module.exports = ".title{\n  display: block;\n  font-size: .8em;\n  font-weight: bold;\n  color: #444;\n}\n\nhr{\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\n\n.name{\n  font-size: 1.2em;\n  text-transform: uppercase;\n}\n\ni{\n  font-weight: bold;\n}\n\n.no-image{\n  font-size:300px;\n  color: #ccc;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/pages/Dashboard/AdminDashboardPages/funding/fund-requests/approve-css.css
// module id = ./src/app/home/pages/Dashboard/AdminDashboardPages/funding/fund-requests/approve-css.css
// module chunks = main